import React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { BrowserRouter } from 'react-router-dom';

import Auth from './pages/Auth';
import Card from './pages/Card';
import Registration from './pages/Registration';
import Time from './pages/Time';
import CardService from './service/CardService';

const PrivateRoute = ({ children, ...rest }: any) => {
  const auth = CardService.isAuth();

  return (
    <Route
      {...rest}
      render={({ location }) => (auth ? (
        children
      ) : (
        <Redirect
          to={{
            pathname: '/auth',
            state: { from: location },
          }}
        />
      ))}
    />
  );
};

const App = () => {
  const local = CardService.isLocal();

  if (local) {
    return (
      <Card />
    );
  }

  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/auth">
          <Auth />
        </Route>
        <Route exact path="/registration">
          <Registration />
        </Route>
        <PrivateRoute exact path="/">
          <Card />
        </PrivateRoute>
        <PrivateRoute exact path="/time">
          <Time />
        </PrivateRoute>
        <Route path="*">
          <Redirect to="/auth" />
        </Route>
      </Switch>
    </BrowserRouter>
  );
};
export default App;
